import Link from '@mui/material/Link';

export type { LinkProps as MuiLinkProps } from '@mui/material/Link';

export default Link;
